import React, { useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from './AppContext';
import { PageContext } from './PageContext';
import { WebsiteContext } from './WebsiteContext';
export const PlayerToolbarContext = React.createContext({})

export const PlayerToolbarContextProvider = ({ children }) => {
    const appContext = useContext(AppContext);
    const pageContext = useContext(PageContext);
    const websiteContext = useContext(WebsiteContext);
    const refClickTimer = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const [hidingMenu, setHidingMenu] = useState(false);
    const [mouseOver, setMouseOver] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [lastTouch, setLastTouch] = useState(null);
    const [isShowQualityMenu, setIsShowQualityMenu] = useState(false);
    useEffect(() => {
        if(initialized){
            if(!mouseOver){
                setHidingMenu(true);
            }
        }
    }, [initialized]);
    useEffect(() => {
        if(lastTouch){
            if(refClickTimer.current) {
                clearTimeout(refClickTimer.current)
            }
            refClickTimer.current = setTimeout(() => {
                setHidingMenu(true);
            }, 5000)
        }
        
    }, [lastTouch]);
    useEffect(() => {
        setHidingMenu(false);
    }, [showMenu]);
    useEffect(() => {
        if(hidingMenu){
            setIsShowQualityMenu(false);
        }
    }, [hidingMenu]);
    useEffect(() => {
        if(pageContext.activePage && pageContext.activePage !== "home"){
            websiteContext.setIsShowBackVideo(false)
        }
        if(appContext.isCameFromHome){
            if(pageContext.activePage !== "home" && !initialized){
                setShowMenu(true);
                setTimeout(() => {
                    setInitialized(true);
                }, 5000)
            }
        }else{
            setInitialized(true);
        }
        
    }, [pageContext.activePage])
    const onTouchStart = (e) => {
        if((!appContext.isMobile && !appContext.isTablet) || pageContext.hidePage || !initialized) return;
        setLastTouch(new Date())
        if(showMenu){
            if(e.target.id && e.target.id.startsWith("menu-")){
                setHidingMenu(true);
            }
        }else{
            if(e.target.id && e.target.id.startsWith("menu-")){
                setShowMenu(true);
            }
        }
        
    }
    const onShowMenu = (e) => {
        if(appContext.isMobile || appContext.isTablet || pageContext.hidePage || !initialized) return;
        setMouseOver(true);
        if(!initialized) return;
        setShowMenu(true);
    }
    const onHideMenu = (e) => {
        if(appContext.isMobile || appContext.isTablet || !initialized) return;
        setMouseOver(false);
        if(!initialized) return;
        setHidingMenu(true);
    }
    const onClickShowOrHideMenu = (e) => {
        if((appContext.isMobile || appContext.isTablet) || pageContext.hidePage || !initialized) return;
        setLastTouch(new Date())
        if(showMenu){
            setHidingMenu(true);
        }else{
            setShowMenu(true);
        }
    }
    return (
      <PlayerToolbarContext.Provider value={{
        showMenu,
        hidingMenu,
        mouseOver,
        initialized,
        lastTouch,
        isShowQualityMenu,
        setShowMenu,
        setHidingMenu,
        setMouseOver,
        setInitialized,
        setLastTouch,
        setIsShowQualityMenu,
        onTouchStart,
        onShowMenu,
        onHideMenu,
        onClickShowOrHideMenu

      }}>
        {children}
      </PlayerToolbarContext.Provider>
    );
  };